
const createNS = function (fqName, cls) {
    let nsparts = fqName.split('.');
    let parent = window;
    // we want to be able to include or exclude the root namespace
    // So we strip it if it's in the namespace
    if (nsparts[0] === 'window') {
        nsparts = nsparts.slice(1);
    }
    // check if we have to only create ns or ns+cls=a fully qualified class name
    const modulesCount = cls !== undefined ? nsparts.length - 1 : nsparts.length;
    // loop through the parts and create
    // a nested namespace if necessary
    for (let i = 0; i < modulesCount; i++) {
        const partname = nsparts[i];
        // check if the current parent already has
        // the namespace declared, if not create it
        if (typeof parent[partname] === 'undefined') {
            parent[partname] = {};
        }
        // get a reference to the deepest element
        // in the hierarchy so far
        parent = parent[partname];
    }
    // the parent is now completely constructed
    // with empty namespaces and can be used.
    if (cls !== undefined) {
        // finally add class to ns if cls found
        parent[nsparts[modulesCount]] = cls;
    }
    return parent;
};
export default createNS;
